// A tab's words from a game record: the short date and the opponent, and a
// longer tooltip with both players and the result.

export interface TabRecord {
  owner: string;
  white: { name: string; rating?: number };
  black: { name: string; rating?: number };
  result: string;
  playedAt: string;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Sep 12", or "" for an unreadable date. */
export function shortDate(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : `${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()}`;
}

/** The player who is not the owner; the white player when the owner is neither. */
export function opponentOf(record: TabRecord): string {
  const owner = record.owner.trim().toLowerCase();
  if (record.white.name.trim().toLowerCase() === owner) return record.black.name;
  if (record.black.name.trim().toLowerCase() === owner) return record.white.name;
  return `${record.white.name} – ${record.black.name}`;
}

/** The pinned tab's fixed label: the game the review opened. */
export const CURRENT_GAME = 'Current game';

/**
 * An opened tab's label: its date and what its opener said about it, e.g.
 * "Sep 12 · −2.8"; the opponent when there is no caption.
 */
export function tabLabel(record: TabRecord, caption?: string): string {
  const date = shortDate(record.playedAt);
  const after = caption ?? `vs ${opponentOf(record)}`;
  return date ? `${date} · ${after}` : after;
}

/** "Sep 12 · edblackknight (1500) – other (1480) · 1-0": date, players, result. */
export function tabTitle(record: TabRecord): string {
  const side = (p: { name: string; rating?: number }) => (p.rating ? `${p.name} (${p.rating})` : p.name);
  const date = shortDate(record.playedAt);
  const players = `${side(record.white)} – ${side(record.black)} · ${record.result}`;
  return date ? `${date} · ${players}` : players;
}
